import { render, staticRenderFns } from "./DeleteTemplateFolderModal.vue?vue&type=template&id=57ccbf04&scoped=true"
import script from "./DeleteTemplateFolderModal.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateFolderModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteTemplateFolderModal.vue?vue&type=style&index=0&id=57ccbf04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ccbf04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ccbf04')) {
      api.createRecord('57ccbf04', component.options)
    } else {
      api.reload('57ccbf04', component.options)
    }
    module.hot.accept("./DeleteTemplateFolderModal.vue?vue&type=template&id=57ccbf04&scoped=true", function () {
      api.rerender('57ccbf04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/DeleteTemplateFolderModal.vue"
export default component.exports